// extracted by mini-css-extract-plugin
export default {"healthStatusBoxContainer":"style_healthStatusBoxContainer__JZj-0","message":"style_message__SrItJ"};